import React from "react";
import { ClientServiceTermsManagementFilterSubHeader } from "../../layouts/ClientServiceTermsManagementLayout";
import ServiceTermsManagementDetailed from "../../features/servicetermsmanagementdetailed";


const ServiceTermsDetailedPage = () => 
    <React.Fragment>
        <ClientServiceTermsManagementFilterSubHeader />
             <section className="px-4 my-3 h-100">
                <ServiceTermsManagementDetailed />
             </section>
    </React.Fragment>

export default ServiceTermsDetailedPage;